export default [
    {
        path: '/enrollment-form/',
        component: require('./pages/enrollment-form.vue')
    },
    {
        path: '/bank-return/',
        component: require('./pages/bank-return.vue')
    },
    {
        path: '/list-departments/',
        component: require('./pages/list-departments.vue')
    },
]


// WEBPACK FOOTER //
// ./src/routes.js